import React, { useEffect, useState } from "react";
import { useFetchUserData } from "../hooks/user/useFetchUserData";
import formatTimestampForNotification from "../lib/formatTimestampForNotification";
import useSocketStore from "../StatesStore/Socket";
import { useNavigate } from "react-router-dom";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { UserAuth } from "../Context";
import ProfilePicture from "../UserProfile/ProfilePicture";

function PostComment({ notification }) {
  const { userData } = useFetchUserData(notification?.id[0]);
  const [isSeen, setIsSeen] = useState(notification.seen);
  const { user } = UserAuth();
  const navigate = useNavigate();
  const [isRecipientOnline, setIsRecipientOnline] = useState(false);
  const socket = useSocketStore((state) => state.socket);

  useEffect(() => {
    if (userData?.userId && socket) {
      // Listen for status updates for the specific firstUser
      const handleUserStatus = ({ userId, status }) => {
        if (userId === userData?.userId) {
          setIsRecipientOnline(status === "online");
        }
      };

      // Register the listener
      socket.on("user status", handleUserStatus);

      // Request initial status of the firstUser
      socket.emit("get user status", userData?.userId);
    }
  }, [userData?.userId]);

  const handleNavigate = async () => {
    try {
      // Navigate to the dynamic route
      navigate(`/post/${notification.postId}`);

      // Update the 'seen' attribute to true in Firestore
      if (!isSeen) {
        setIsSeen(true);
        const notificationRef = doc(
          db,
          "users",
          user?.uid,
          "notifications",
          notification.notificationId
        );
        await updateDoc(notificationRef, { seen: true });
      }
    } catch (error) {
      console.error("Error updating notification: ", error);
    }
  };
  return (
    <>
      <li
        onClick={handleNavigate}
        className="border-bottom"
        style={{
          padding: "0.625rem 1rem",
          cursor: "pointer",
          backgroundColor: !isSeen ? "#FAFBFF" : "transparent",
        }}
      >
        <div
          className={`d-flex my-0`}
          style={{ display: "inline-flex", gap: "12px", cursor: "pointer" }}
        >
          <div
            style={{ height: "50px", width: "50px" }}
            className={`avatar text-center d-inline-block ${
              isRecipientOnline ? "status-online" : " "
            }`}
          >
            <ProfilePicture userData={userData} />
          </div>
          <div
            className={`w-100 rounded-2 p-0 d-flex align-items-center justify-content-center `}
          >
            <div
              className="w-100 d-flex gap-2 flex-column justify-content-between p-0"
              style={{ fontFamily: "Inter", color: "#676A79", fontWeight: 600 }}
            >
              <div className="d-flex flex-grow-1">
                <p className={`small mb-0 d-flex flex-column`}>
                  <span
                    style={{
                      fontFamily: "Inter",
                      color: "#000000",
                      fontWeight: 500,
                      fontSize: "16px",
                    }}
                  >
                    {userData?.userName}
                  </span>
                  <span style={{ fontSize: "15px" }}>
                    Commented on your post.
                  </span>
                </p>
              </div>
              {/* Comment Box */}
              <div
                style={{
                  fontSize: "13px",
                  borderLeft: "2px solid #0085FF",
                  padding: "4px 13px",
                }}
              >
                {notification?.comment}
              </div>
              <div className="small mb-1" style={{ fontSize: "12px" }}>
                {formatTimestampForNotification(notification.timestamp)}
              </div>
            </div>
          </div>
        </div>
      </li>
    </>
  );
}

export default PostComment;
